
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { AlertTriangle, Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface BackendErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSlowResponse?: boolean;
}

const BackendErrorModal: React.FC<BackendErrorModalProps> = ({
  isOpen,
  onClose,
  isSlowResponse = false
}) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-100 rounded-full">
            {isSlowResponse ? (
              <Loader className="w-6 h-6 text-red-600 animate-spin" />
            ) : (
              <AlertTriangle className="w-6 h-6 text-red-600" />
            )}
          </div>
          <AlertDialogTitle className="text-center">
            {isSlowResponse ? t('backend_slow_response') : t('backend_error_detected')}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {isSlowResponse ? t('backend_slow_message') : t('backend_error_message')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose} className="w-full">
            {isSlowResponse ? t('understood') : t('retry')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default BackendErrorModal;
